/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import customerTranslations from "./customerTranslations";

const alimonyTranslations = {
  customer: customerTranslations,
  label: "Unterhalt",
  children: {
    childOf: {
      petitioner: "Mein Kind",
      partner: "Kind des anderen Elternteils",
      both: "Gemeinsames Kind",
    },
    livesWith: {
      petitioner: "bei mir",
      partner: "beim anderen Elternteil",
      both: "zu gleichen Teilen bei beiden Elternteilen",
      none: "bei einer anderen Person",
    },
    childAllowanceReceiver: {
      petitioner: "ich",
      partner: "anderer Elternteil",
      child: "das Kind selbst",
      none: "keiner",
    },
  },
  alimonyPetitioner: {
    employmentStatus: {
      employed: "Angestellt",
      selfEmployed: "Selbstständig",
      unemployed: "Nicht erwerbstätig",
    },
    livingSituation: {
      tenant: "Zur Miete",
      ownerWithMortgage: "Eigentumsimmobilie in Finanzierung",
      ownerOutright: "Eigentumsimmobilie",
      other: "Weder Miete noch Eigentum",
    },
    netIncome: {
      label: "Monatliches durchschnittliches Nettoeinkommen",
    },
    otherIncome: {
      label: "Sonstige monatliche Einkünfte (netto)",
    },
    livingExpenses: {
      label: "Warmmiete",
    },
    monthlyMortgagePayment: {
      label: "Kreditrate",
    },
    monthlyImputedRent: {
      label: "Wohnwert",
    },
  },
  alimonyPartner: {
    employmentStatus: {
      employed: "Angestellt",
      selfEmployed: "Selbstständig",
      unemployed: "Nicht erwerbstätig",
    },
    livingSituation: {
      tenant: "Zur Miete",
      ownerWithMortgage: "Eigentumsimmobilie in Finanzierung",
      ownerOutright: "Eigentumsimmobilie",
      other: "Weder Miete noch Eigentum",
    },
    netIncome: {
      label: "Monatliches durchschnittliches Nettoeinkommen",
      helperText: "Geben Sie hier bitte das durchschnittliche monatliche Gehalt der letzten 12 Monate an (Boni, Zulagen, Weihnachtsgeld usw. einberechnet).",
    },
    otherIncome: {
      label: "Sonstige monatliche Einkünfte (netto)",
    },
    livingExpenses: {
      label: "Warmmiete",
    },
    monthlyMortgagePayment: {
      label: "Kreditrate",
    },
    monthlyImputedRent: {
      label: "Wohnwert",
    },
  },
  expensesCategory: {
    debtRepayment: "Tilgung von Schulden",
    insurer: "Versicherung",
    privatePension: "Private Altersvorsorge",
    visitationCosts: "Kosten für Umgangsrecht",
    other: "Sonstiges",
  },
};

export default alimonyTranslations;
